import styled from '@emotion/styled'
import { mergeDeepRight } from 'ramda'
import { QUERIES } from 'styling/variables'

export const SecondColumn = styled('div')(({ customCss = {} }) =>
  mergeDeepRight({}, customCss),
)
